import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function getManagementCompaniesRequest(
	term: string,
	nullCifOnly: boolean,
	page: number,
	size: number
) {
	return await apiClient
		.get(API.QUERY.ADMIN.MANAGEMENT_COMPANIES(term, nullCifOnly, page, size))
		.then((res) => res.data);
}

export function useGetManagementCompanies(
	term: string,
	nullCifOnly: boolean,
	page: number,
	size: number
) {
	return useQuery<ManagementCompany[], AxiosError>({
		queryKey: ["adminManagementCompanies"],
		queryFn: () => getManagementCompaniesRequest(term, nullCifOnly, page, size),
		gcTime: 1000 * 60 * 60 * 24
	});
}
